import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { SuperAdminService } from 'src/app/services/super-admin.service';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-mi-physical-verifications',
  templateUrl: './mi-physical-verifications.component.html',
  styleUrls: ['./mi-physical-verifications.component.scss']
})
export class MiPhysicalVerificationsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService,
     private adminservice: SuperAdminService,
      private messageService: MessageService, 
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

 public geoMappings: any[] = [];
  public loading = false;

  //public userID: string = '';
  public userRole: string = '';
  public jeLogin: boolean = false;
  public xenLogin: boolean = false;
  public ddAssociateLogin: boolean = false;
  public dimicadaLogin: boolean = false;
  public filteredGeoMappings: any[] = [];
  public showGeoDialog = false;
  hoveredRow: number = -1;

  ngOnInit() {
  this.initializeUserFromToken();
    this.loadGeoMappings();

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


      let parentRoute = this.router.url.split('/')[1];
      this.route.queryParams
        .subscribe(params => {
          // this.autoId = params.autoId;
          // this.appId = params.appId;
          this.items = [
            { label: 'Pending', routerLink: `/${parentRoute}/physical-verification/pending`},
            { label: 'Current', routerLink: `/${parentRoute}/physical-verification/current`},
            { label: 'Further Action Taken', routerLink: `/${parentRoute}/physical-verification/approved` },     
            // {
            // label: 'View Assign Area',
            // command: () => this.openGeoMappingPopup() // 👈 opens dialog instead of routing
            // }
          ];
        }
        );
    }


/// ✅ Extract user info from token
  initializeUserFromToken() {
    const token = sessionStorage.getItem('token');
    if (token) {
      const tokenData = JSON.parse(this.cryptoJsService.DecryptToken(token));

      this.userID = tokenData?.userID || '';
      this.userRole = tokenData?.role || '';

      console.log('🔐 Token data:', tokenData);

      if (tokenData?.role === 'JE' || tokenData?.role === 'CJE') {
        this.jeLogin = true;
      } else if (tokenData?.role === 'XEN' || tokenData?.role === 'CXEN') {
        this.xenLogin = true;
      } else if (tokenData?.role === 'DMICADA') {
        this.dimicadaLogin = true;
      } else if (tokenData?.role === 'DD Associate') {
        this.ddAssociateLogin = true;
      }
    }
  }

  // ✅ Fetch all mappings, then filter by userID
  loadGeoMappings() {
    this.loading = true;
    console.log(`📡 Fetching GeoMappings for userID: ${this.userID}`);

    this.adminservice.GetAllGeoMappings().subscribe({
      next: (res: any) => {
        console.log('✅ Full API Response:', res);
        this.geoMappings = res?.$values || [];

        // ✅ Filter by logged-in userID
        this.filteredGeoMappings = this.geoMappings.filter(
          (item: any) => item.userID === this.userID
        );

        console.log('🎯 Filtered Mappings:', this.filteredGeoMappings);

        if (this.filteredGeoMappings.length === 0) {
          this.messageService.add({
            severity: 'info',
            summary: 'No Areas Assigned',
            detail: `No areas assigned for ${this.userID} (${this.userRole}).`
          });
        }

        this.loading = false;
      },
      error: (err) => {
        console.error('❌ Error loading geo mappings:', err);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load Geo Mappings'
        });
      }
    });
  }

  // ✅ Open dialog
  openGeoMappingPopup() {
    this.showGeoDialog = true;
  }

  // ✅ Close dialog
  onGeoDialogClose() {
    this.showGeoDialog = false;
  }
}

